import assert from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {ManifestationV4} from '../types';
import {selectMetadataEditSavedMetadataManifestationById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';

export const useAssertSavedManifestation = (
  manifestationId: string,
): ManifestationV4 => {
  const selector = useCreateSelectorById(
    manifestationId,
    selectMetadataEditSavedMetadataManifestationById,
  );
  const manifestation = useAppSelector(selector);
  return assert(manifestation, 'useAssertSavedManifestation: not loaded');
};
